"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var react_1 = require("react");
var RequirementsUtility_1 = require("../../../utils/RequirementsUtility");
var ReceiverRequirements_1 = require("../../types/ReceiverRequirements");
var form_item_1 = __importDefault(require("../form-item"));
var translationMessages = {
    baseInformation_customerContactName: {
        id: "baseInformation_customerContactName",
        defaultMessage: "Contact name",
    },
};
var CustomerContactName = function (props) {
    var _a = react_1.useState(""), customerContactNameHandlingValidationStatus = _a[0], setCustomerContactNameHandlingValidationStatus = _a[1];
    var _b = react_1.useState({}), customerContactNameFieldProps = _b[0], setCustomerContactNameFieldProps = _b[1];
    var _c = react_1.useState(false), loadingCustomerContactNameValues = _c[0], setLoadingCustomerContactNameValues = _c[1];
    var customerContactNameFieldDefinition = RequirementsUtility_1.getFieldRequirements(props.receiverRequirements, ReceiverRequirements_1.AvailableFields["customer.contact.name"]);
    if (customerContactNameFieldDefinition) {
        return (React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["customer.contact.name"], defaultLabel: props.intl.formatMessage(translationMessages.baseInformation_customerContactName), defaultIsRequired: false, fieldName: ["invoice", "customer", "contact", "name"], validateStatus: customerContactNameHandlingValidationStatus }, RequirementsUtility_1.getInput(customerContactNameFieldDefinition, ["invoice", "customer", "contact", "name"], "handleCostCenterValidation", props.legalIdentifier, props.formInstance, props.rapiBaseUrl, props.receiverRequirements, props.updateReceiverRequirementsProp, setCustomerContactNameFieldProps, customerContactNameFieldProps, setLoadingCustomerContactNameValues, loadingCustomerContactNameValues, setCustomerContactNameHandlingValidationStatus, true)));
    }
    else {
        return null;
    }
};
exports.default = react_intl_1.injectIntl(CustomerContactName);
